import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class Globals{
    previeModeStatus():boolean {
        return window.location.search.indexOf('fullview=true') >= 0;
    }
    embededModeStatus():boolean {
        return window.location.search.indexOf('embeded=true') >= 0;
    }
}